// Deterministic friendly color per user_id (hash → palette index)
const PALETTE = [
  "#007AFF", // blue
  "#FF9500", // orange
  "#AF52DE", // purple
  "#FF2D55", // pink
  "#5AC8FA", // teal
  "#FFCC00", // yellow
  "#00C7BE", // mint
  "#A2845E", // brown
  "#5E5CE6", // indigo
  "#30B0C7", // cyan
];

export function colorForUser(id) {
  if (!id) return PALETTE[0];
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function initialsOf(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const isFamilyContact = (c) =>
  c?.relation === "family" || c?.relation === "child" || c?.relation === "parent";
